import { USSDMenuItem } from '../ussdState';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export const createMainMenu = (): USSDMenuItem => {
  return {
    id: 'main',
    label: 'AGXL CBS',
    type: 'menu',
    children: [
      {
        id: 'log_activity',
        label: 'Log Activity',
        type: 'menu',
        children: [], // Will be populated by LogActivity
      },
      {
        id: 'check_score',
        label: 'Check Score',
        type: 'display',
        action: async () => {
          // This will be handled by the CheckScore screen
        },
      },
      {
        id: 'view_activities',
        label: 'View Activities',
        type: 'action',
        action: () => {
          toast.info('Opening activity log...');
          // In a real app, this would navigate or show data
        },
      },
      {
        id: 'help',
        label: 'Help',
        type: 'display',
        action: () => {
          toast.info('Help section');
        },
      },
      {
        id: 'exit',
        label: 'Exit',
        type: 'action',
        action: () => {
          // Session will be ended by selecting 0
        },
      },
    ],
  };
};
